import type { SimulacaoLinkTarget } from '../types';

/**
 * Só abre `https:` sem credencial na URL. `http:` sai sem TLS e `user:senha@` é a forma clássica
 * de disfarçar o host (`https://banco.com@golpe.com`): os dois viram 'Link inseguro' (CA-18).
 * O que nem é URL (texto solto, `javascript:`) também não abre.
 */
export const classificarLink = (valor: string | null | undefined): SimulacaoLinkTarget => {
  if (!valor?.trim()) return null;
  try {
    const url = new URL(valor.trim());
    if (url.protocol !== 'https:' || url.username || url.password) return { safe: false };
    return { safe: true, href: url.href };
  } catch {
    return { safe: false };
  }
};

/** Qualquer `esquema://...` conta como link: o inseguro também precisa aparecer marcado. */
const LINK_NO_TEXTO = /\b[a-z][a-z0-9+.-]*:\/\/[^\s<>"']+/giu;
const PONTUACAO_FINAL = /[.,;:!?)\]]+$/u;

/** Links de um texto da conversa, na ordem em que aparecem e sem a pontuação que fecha a frase. */
export const extrairLinks = (texto: string): string[] =>
  Array.from(texto.matchAll(LINK_NO_TEXTO), ([link]) => link.replace(PONTUACAO_FINAL, ''));
